module.exports = __webpack_public_path__ + "img/bz.3f9ea4a8.png";